import PropTypes from 'prop-types';
import React from 'react';
import { HorizontalSwitch } from '@surfline/quiver-react';

const ForecastTableControls = ({ expandAllDays, filterTop3Swells, toggleFilterTop3Swells }) => (
  <div className="sl-forecast-table-controls">
    <button
      type="button"
      className="sl-forecast-table-controls__expand-collapse"
      onClick={() => expandAllDays(true)}
    >
      Expand all
    </button>
    &nbsp;/&nbsp;
    <button
      type="button"
      className="sl-forecast-table-controls__expand-collapse"
      onClick={() => expandAllDays(false)}
    >
      Collapse all
    </button>
    <div className="sl-forecast-table-controls__swell-toggle">
      <HorizontalSwitch
        position={filterTop3Swells ? 'LEFT' : 'RIGHT'}
        onClick={toggleFilterTop3Swells}
      />
    </div>
  </div>
);

ForecastTableControls.propTypes = {
  expandAllDays: PropTypes.func.isRequired,
  filterTop3Swells: PropTypes.bool,
  toggleFilterTop3Swells: PropTypes.func.isRequired,
};

ForecastTableControls.defaultProps = {
  filterTop3Swells: false,
};

export default ForecastTableControls;
